import {useCallback} from "react";
import {call, fork} from "redux-saga/effects";

import {useRecaptcha} from "../utils/recaptcha";
import {actions, useSagaCallback} from "../store/sagas";
import {putFeedback} from "../store/feedback";
import {apiPost, setApiCredentials} from "./client";
import {getToken} from "./sign_in";
import {loadUserProfile} from "./user";
import {globalSignOn} from "./sso";

export const useSignUp = (feedbackCh) => {
    const recaptcha = useRecaptcha();
    return useSagaCallback(feedbackCh, useCallback(function* (data) {
        yield actions.autoSignInCanceled();
        yield putFeedback({busy: true});
        let result;
        try {
            data["captcha-response"] = yield call(recaptcha);
            result = yield call(apiPost, `/api/v2/user/create`, data);
            const [key, secret] = yield call(getToken);
            setApiCredentials(key, secret);
        } finally {
            yield putFeedback({busy: false});
        }
        if (result.sso_token) {
            yield fork(globalSignOn, result.sso_token);
        }
        yield fork(function*() {
            yield call(loadUserProfile);
        });
        return result;
    }, [recaptcha]));
};
